import Clock from '../../../../../../components/forms/Clock';
import { partnerData } from '../../../../utils/partnerHelpers';

const BusinessHoursSection = ({ formData, setFormData, onDaysChange }) => {
  return (
    <div className="space-y-3 sm:space-y-4">
      <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
        Opening closing time & business days <span className="text-rose-500 ml-0.5">*</span>
      </label>

      {/* Days of Week */}
      <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-4">
        {partnerData.daysOfWeek.map((day) => {
          const isSelected = formData.businessHours?.days?.includes(day);
          return (
            <button
              key={day}
              type="button"
              onClick={() => onDaysChange(day)}
              className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl text-xs sm:text-sm font-bold transition-all cursor-pointer ${
                isSelected
                  ? 'bg-teal-50 text-[#067978] border-2 border-[#067978]/30'
                  : 'bg-slate-50 text-slate-500 border-2 border-transparent hover:bg-slate-100'
              }`}
            >
              {day}
            </button>
          );
        })}
      </div>

      {/* 24-Hour Time Selectors with Security Validation Layers */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <div className="space-y-1.5">
          <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
            Opening time <span className="text-rose-500 ml-0.5">*</span>
          </label>
          <Clock
            value={formData.businessHours?.openingTime || ''}
            onChange={(val) =>
              setFormData((prev) => ({
                ...prev,
                businessHours: { ...prev.businessHours, openingTime: val }
              }))
            }
            placeholder="Select Opening Time"
          />
        </div>
        <div className="space-y-1.5">
          <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
            Closing time <span className="text-rose-500 ml-0.5">*</span>
          </label>
          <Clock
            value={formData.businessHours?.closingTime || ''}
            onChange={(val) =>
              setFormData((prev) => ({
                ...prev,
                businessHours: { ...prev.businessHours, closingTime: val }
              }))
            }
            placeholder="Select Closing Time"
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessHoursSection;
